// extracted by mini-css-extract-plugin
export default {"statsView":"GoalStatsView_statsView__SeoTV","item":"GoalStatsView_item__ddyjU"};